import { Menu, MenuItem } from "@mui/material";
import TableComponent from "components/TableComponent";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Button, Card, Col, Container, Input, Row, Table } from "reactstrap";
import { athleteAnnualEarning } from "store/actions/additionalEarningAction";
import { getAthlete } from "store/actions/additionalEarningAction";

const AthleteAnnualEarning = () => {
  const { id } = useParams();
  let dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState("2023");
  useEffect(() => {
    dispatch(getAthlete(id));
    dispatch(athleteAnnualEarning(id, selectedOption));
  }, []);
  useEffect(() => {
    dispatch(athleteAnnualEarning(id, selectedOption));
  }, [selectedOption]);
  const [anchorEl, setAnchorEl] = useState(null);
  const { athlete, athleteAnnualEarnings } = useSelector(
    (state) => state.earnings
  );
  const [name, setName] = useState(
    athlete?.first_name + " " + athlete?.last_name
  );
  const [athleteId, setAthleteId] = useState(athlete.athleteID);
  useEffect(() => {
    setName(athlete?.first_name + " " + athlete?.last_name);
    setAthleteId(athlete.athleteID);
  }, [athlete]);

  const date = moment.unix(athlete?.created_at?.seconds).format("DD MMM YYYY");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuItemClick = (event) => {
    setSelectedOption(event.target.innerText);
    setAnchorEl(null);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const columnsAnnual = [
    `${selectedOption} Earning`,
    "$ Chat (distributed to athlete)",
    "$ Group Chat (distributed to athlete)",
    "$ Sport Badge",
    "$ Endorsement Badge",
    "$ Talking Badge",
    "$ Seasonal Badge",
    "$ Honor Badge",
    "$ Vote-getter Badge",
    "$ Momento",
    "Athlete Monthly Total",
  ];

  const keyMapAnnual = {
    [`${selectedOption} Earning`]: "dateRange",
    "$ Chat (distributed to athlete)": "chatsAmountEarned",
    "$ Group Chat (distributed to athlete)": "groupChatsAmountEarned",
    "$ Sport Badge": "sport_badges",
    "$ Endorsement Badge": "endorsement_badge",
    "$ Talking Badge": "talking_badge",
    "$ Seasonal Badge": "seasonal_badge",
    "$ Honor Badge": "honor_badge",
    "$ Vote-getter Badge": "vote_getter_badge",
    "$ Momento": "momento",
    "Athlete Monthly Total": "monthlyTotal",
  };

  const formatData = (data) => {
    return data.map((item) => ({
      ...item,
      chatsAmountEarned: "$" + item.chatsAmountEarned,
      groupChatsAmountEarned: "$" + item.groupChatsAmountEarned,
      sport_badges: "$" + item.sport_badges,
      endorsement_badge: "$" + item.endorsement_badge,
      talking_badge: "$" + item.talking_badge,
      seasonal_badge: "$" + item.seasonal_badge,
      honor_badge: "$" + item.honor_badge,
      vote_getter_badge: "$" + item.vote_getter_badge,
      momento: "$" + item.momento,
      monthlyTotal: "$" + item.monthlyTotal,
    }));
  };

  return (
    <>
      <Container fluid className="my-2">
        <div className="p-3">
          <Link to={`/admin/players-earning/${id}`} className="btn btn-primary">
            Go Back
          </Link>
        </div>
        <div className="d-flex flex-column align-items-center">
          <Row className="w-100 px-2 px-md-4 mt-3">
            <Col
              md="6"
              lg="4"
              className="mb-3 mb-md-0 d-flex flex-column justify-content-center"
            >
              <span className="mr-2 text-nowrap mb-2">Athlete Id (reg#)</span>
              <Input
                value={athleteId}
                placeholder="Athlete id"
                className="w-100"
                readOnly
              />
            </Col>
            <Col
              md="6"
              lg="3"
              className="mb-3 mb-md-0 d-flex flex-column justify-content-center"
            >
              <span className="mr-2 mb-2">Name</span>
              <Input value={name} placeholder="Enter Name" readOnly />
            </Col>
            <Col
              md="6"
              lg="3"
              className="mb-3 mb-md-0 d-flex flex-column justify-content-center"
            >
              <span className="mr-2 mb-2 text-nowrap">Date Register</span>
              <Input value={date} placeholder="Enter date" readOnly />
            </Col>
            <Col
              md="6"
              lg="2"
              className="d-flex justify-content-center align-items-end"
            >
              <Button color="primary" onClick={handleClick}>
                Select Year
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleMenuItemClick}>2023</MenuItem>
                <MenuItem onClick={handleMenuItemClick}>2024</MenuItem>
                <MenuItem onClick={handleMenuItemClick}>2025</MenuItem>
              </Menu>
            </Col>
          </Row>
          <div className="w-100 d-flex justify-content-center my-3 mx-0 mx-md-4">
            <Card className="p-3">
              <TableComponent
                columns={columnsAnnual}
                data={
                  athleteAnnualEarnings?.stats?.length > 0
                    ? formatData(athleteAnnualEarnings.stats)
                    : []
                }
                keyMap={keyMapAnnual}
                className="align-items-center table-flush mt-3"
              />
              <div
                className="mt-3 d-flex flex-column justify-content-center
align-items-end"
              >
                <div className="text-center">
                  <p>Total for {athleteAnnualEarnings.annualTotal}</p>
                  <Button color="primary">DOWNLOAD</Button>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </Container>
    </>
  );
};

export default AthleteAnnualEarning;
